import {withComponent} from '../../hoc/withComponent';
import {DialogContentBase} from './DialogContentBase';

export const withDialogContent = withComponent(DialogContentBase);
